const REQUIRED_KEYS = [
  'REACT_APP_GOOGLE_MAPS_API_KEY',
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN',
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_APP_ID'
];

const CONFIG_ENDPOINT = '/api/frontend-config';
const REQUEST_TIMEOUT_MS = 2000;

const getCurrentEnv = () => {
  if (typeof window === 'undefined') {
    return {};
  }
  const env = window._env_;
  return env && typeof env === 'object' ? env : {};
};

const hasRequiredKeys = (env) => REQUIRED_KEYS.every((key) => Boolean(env[key]));

const mergeEnv = (current, incoming) => {
  const merged = { ...current };
  for (const [key, value] of Object.entries(incoming || {})) {
    if (!key.startsWith('REACT_APP_')) {
      continue;
    }
    const trimmedValue = typeof value === 'string' ? value.trim() : '';
    const existing = merged[key];
    if (!existing && trimmedValue) {
      merged[key] = trimmedValue;
    }
  }
  return merged;
};

const fetchFrontendConfig = async () => {
  if (typeof window === 'undefined' || typeof fetch !== 'function') {
    return null;
  }
  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
  const timeoutId = controller ? setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS) : null;
  try {
    const response = await fetch(CONFIG_ENDPOINT, {
      method: 'GET',
      credentials: 'omit',
      signal: controller ? controller.signal : undefined
    });
    if (!response.ok) {
      return null;
    }
    const payload = await response.json();
    return payload && typeof payload === 'object' ? payload : null;
  } catch (err) {
    return null;
  } finally {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }
};

export const ensureRuntimeConfig = async () => {
  if (typeof window === 'undefined') {
    return {};
  }
  const current = getCurrentEnv();
  if (hasRequiredKeys(current)) {
    window._env_ = current;
    return current;
  }

  const incoming = await fetchFrontendConfig();
  if (incoming) {
    const merged = mergeEnv(current, incoming);
    window._env_ = merged;
    return merged;
  }

  window._env_ = current;
  return current;
};
